<p>single-document works!</p>
